import { useAuth } from "../../auth/AuthProvider";
import { getLocationString } from "../../shared/utils/Location";
import {
  createBecomeMemberPath,
  useBecomeMemberPath,
} from "../../membership/MembershipPaymentParameters";
import { TextLink } from "@teamscheme/text-link";
import { useMembershipUpgradePageLocation } from "./MembershipUpgradePage";
import { LocationDescriptorObject } from "history";
import StaticRoutes from "../../static-pages/StaticRoutes";

export default function MemberUpgradeText() {
  const targetLocation = useMembershipUpgradePageLocation();
  const becomeMemberPath = useBecomeMemberPath();

  return (
    <MemberUpgradeTextInner
      targetLocation={targetLocation}
      becomeMemberPath={becomeMemberPath}
    />
  );
}

export function StaticMemberUpgradeText() {
  const targetPath = StaticRoutes.createMemberContract.path;
  const targetLocation: LocationDescriptorObject = { pathname: targetPath };
  return (
    <MemberUpgradeTextInner
      targetLocation={targetLocation}
      becomeMemberPath={createBecomeMemberPath(targetPath)}
    />
  );
}

function MemberUpgradeTextInner({
  targetLocation,
  becomeMemberPath,
}: {
  targetLocation: LocationDescriptorObject<any>;
  becomeMemberPath: string;
}) {
  const auth = useAuth();
  return (
    <span>
      <span>For NAF-medlemmer er oppgradering inkludert i medlemskapet.</span>
      {!auth.isAuthenticated ? (
        <span>
          <br />
          <TextLink
            onClick={() =>
              auth.loginWithRedirect({
                targetUrl: getLocationString(targetLocation),
              })
            }
          >
            Logg inn
          </TextLink>{" "}
          for å få tilgang eller{" "}
          <TextLink linkTo={becomeMemberPath}>bli medlem</TextLink>.
        </span>
      ) : null}
    </span>
  );
}
